import React, { useEffect, useState } from "react";
import api from "../../services/api";

// CRM externo (gallera.net CRM / Odoo) embutido como "sistema unico".
// Busca um cracha SSO do backend (identidade do usuario logado) e abre o CRM
// ja autenticado. Se o SSO nao estiver disponivel, cai na URL direta (login manual).
const CRM_URL = process.env.REACT_APP_EXTERNAL_CRM_URL || "";

const CRM = () => {
  const [src, setSrc] = useState("");
  const [erro, setErro] = useState(false);

  useEffect(() => {
    let ativo = true;
    (async () => {
      try {
        const { data } = await api.get("/crm/sso-token");
        if (ativo && data && data.url) {
          setSrc(data.url);
          return;
        }
        throw new Error("sem url");
      } catch (e) {
        // fallback: abre o CRM direto (pedira login) se houver URL configurada
        if (ativo) {
          if (CRM_URL) setSrc(CRM_URL);
          else setErro(true);
        }
      }
    })();
    return () => {
      ativo = false;
    };
  }, []);

  if (erro) {
    return (
      <div style={{ padding: 24, fontFamily: "sans-serif" }}>
        CRM ainda não configurado neste servidor.
      </div>
    );
  }

  return (
    <div
      style={{
        width: "100%",
        height: "calc(100vh - 64px)",
        overflow: "hidden",
        background: "#fff",
      }}
    >
      {src ? (
        <iframe
          title="CRM"
          src={src}
          style={{ width: "100%", height: "100%", border: "none", display: "block" }}
          allow="clipboard-read; clipboard-write; fullscreen; geolocation; microphone; camera"
        />
      ) : (
        <div style={{ padding: 24, fontFamily: "sans-serif" }}>Abrindo o CRM…</div>
      )}
    </div>
  );
};

export default CRM;
